import { request } from '@/utils/request'
// 获取消息列表接口
export const genUserSign = (userId) => {
  return request({
    baseURL: 'cloudTalk',
    url: `/talkCent/genUserSig?userId=${userId}`,
    method: 'get'
  })
}